import React, { useRef } from 'react';

import Spinwheel from '../../common/Spinwheel';
import JoditEditor from 'jodit-react';

const AddOrUpdateAboutUs = ({ modalId, formik, loading }) => {
 const editor = useRef(null);

  return (
    <div className={`modal fade`} id={modalId} tabIndex="-1" aria-labelledby="blogAddModalLabel" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-centered modal-xl" >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="blogAddModalLabel">About Us</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={formik?.handleSubmit}>

              <div className="mb-3"> 
                <label htmlFor="">Header</label>             
                <JoditEditor
                  ref={editor}
                  value={formik?.values?.aboutUs}
                  onBlur={(e) => {
                    formik.setFieldTouched("aboutUs", true)
                    e === "<p><br></p>" ? formik.setFieldValue("aboutUs", "") : formik.setFieldValue("aboutUs", e);
                  }}
                  onChange={(newContent) => { }}
                />
                {formik?.touched?.aboutUs && formik?.errors?.aboutUs ? (<div className='req-error'>{formik?.errors?.aboutUs}</div>) : null}
              </div>

              <div className="mb-3"> 
                <label htmlFor="">Footer</label>             
                <JoditEditor
                  ref={editor}
                  value={formik?.values?.aboutUsFooter}
                  onBlur={(e) => {
                    formik.setFieldTouched("aboutUsFooter", true)
                    e === "<p><br></p>" ? formik.setFieldValue("aboutUsFooter", "") : formik.setFieldValue("aboutUsFooter", e);
                  }}
                  onChange={(newContent) => { }}
                />
                {formik?.touched?.aboutUsFooter && formik?.errors?.aboutUsFooter ? (<div className='req-error'>{formik?.errors?.aboutUsFooter}</div>) : null}
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>  {loading ? <Spinwheel sizeClass={"spin-small"} /> : "Submit"}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrUpdateAboutUs;